import React, { useEffect } from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import Button from "@mui/material/Button";
import Plot from "react-plotly.js";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormHelperText from "@mui/material/FormHelperText";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import Box from "@mui/material/Box";
import Heatmap from "./Heatmap";
import Projectcolors from "../Utils/Colors";
import { ListItemAvatar,Typography } from "@mui/material";
import { baseURL } from "../Config/config";
import GlobalLoader from "./CommonC/GlobalLoader";

const tableCellName = [
  "Tag Name",
  "Description",
  "Unit Of Measure",
  "Minimum",
  "Maximum",
  "Average",
  "Variation(%)",
  "Standard Deviation",
  "Coefficient of Variation",
];
function LinePlotRaw() {
  const [rawdata, setRawData] = React.useState([]);

  const [lineplotdata, setLineplotdata] = React.useState([]);

  const [lineplotx, setLineplotx] = React.useState([]);
  const [x, setX] = React.useState("");
  const [y, setY] = React.useState("");
  const [ylabel, setYLabel] = React.useState("Y axis");
  const [xlabelscatter, setXscatter] = React.useState("");
  const [ylabelscatter, setYscatter] = React.useState("");
  const [alltagname, setTagname] = React.useState([]);
  const colorslist = [
    "#3366cc",
    "#dc3912",
    "#ff9900",
    "#109618",
    "#990099",
    "#0099c6",
    "#dd4477",
    "#aaaa11",
    "#743411",
    "#e67300",
    "#22aa99",
    "#994499",
    "#22aa99",
    "#66aa00",
    "#6633cc",
    "#3366cc",
    "#8b0707",
    "#651067",
    "#329262",
    "#5574a6",
    "#3b3eac",
    "#b77322",
    "#16d620",
    "#b91383",
    "#f4359e",
    "#9c5935",
    "#a9c413",
    "#2a778d",
    "#668d1c",
    "#bea413",
    "#0c5922",
    "#b82e2e",
  ];
  const [colors, setColors] = React.useState(colorslist[0]);
  const [getLoader, setGetLoader] = React.useState(false);

  useEffect(() => {
    getRawData();
  }, []);

  const getRawData = () => {
    setGetLoader(true);
    const ProjectID = sessionStorage.getItem("projectID");
    fetch(`${baseURL}/getrawdata?projectID=${ProjectID}&scatterplot=${0}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    })
      .then((res) => res.json())

      .then((raw) => {
        setRawData(raw.raw_data);
        setLineplotdata(raw.lineplotdata);
        setLineplotx(raw.lineplotdata[0]);
        setTagname(raw.tag_name);
        setX(0);
        setY(1);
        setXscatter(alltagname[0]);
        setYscatter(alltagname[1]);
        setGetLoader(false);
      })
      .catch((err) => {
        setGetLoader(false);
        console.log("caught it!", err);
      });
  };

  function handlerowclick(number) {
    setLineplotx(lineplotdata[number]);
    setYLabel(rawdata[number][1]);
    setXscatter(alltagname[0]);
    setYscatter(alltagname[1]);
    setColors(colorslist[number]);
  }

 return (
  <Box
    sx={{
      width: "100%",
      height: "100%",
      display: "flex",
      flexDirection: "column",
      gap: 2,
      mb:2,
      overflow: "hidden",
    }}
  >
    {/* Data Table Card */}
    <Paper
      elevation={0}
      sx={{
        borderRadius: "18px",
        overflow: "hidden",
        border: "1px solid rgba(0,120,201,.15)",
        boxShadow: "0px 4px 15px rgba(0,0,0,.05)",

      }}
    >
      <TableContainer
        sx={{
          maxHeight: 220,
        }}
      >
        <Table stickyHeader>
          <TableHead>
            <TableRow>
              {tableCellName.map((item, i) => (
                <TableCell
                  key={i}
                  sx={{
                    backgroundColor: "#0078c9",
                    color: "#fff",
                    fontSize: "12px",
                    fontWeight: 600,
                  }}
                >
                  {item}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>

          <TableBody>
            {rawdata?.map((item, i) => (
              <TableRow
                hover
                key={i}
                onClick={() => handlerowclick(i)}
                sx={{
                  cursor: "pointer",
                  transition: ".2s",
                  "&:hover": {
                    background: "rgba(0,120,201,.04)",
                  },
                }}
              >
                {item.map((data, idx) => (
                  <TableCell
                    key={idx}
                    sx={{
                      fontSize: "12px",
                      py: 1.2,
                    }}
                  >
                    {data}
                  </TableCell>
                ))}
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Paper>

    {/* Graph Card */}
    <Paper
      elevation={0}
      sx={{
        borderRadius: "18px",
        p: 2,
        flex: 1,
        boxShadow: "0px 4px 15px rgba(0,0,0,.05)",
      }}
    >
      <Plot
        data={[
          {
            x: Array.from(Array(lineplotx.length).keys()),
            y: lineplotx,
            type: "scatter",
            mode: "lines+markers",
            marker: { color: "#9e0b22" },
            line: { color: "#0078c9" },
          },
        ]}
        layout={{
          autosize: true,
          height: 230,
          margin: {
            l: 50,
            r: 20,
            b: 50,
            t: 30,
          },

          xaxis: {
            title: "Count",
          },

          yaxis: {
            title:
              ylabel.length > 20
                ? ylabel.substring(0,20)+"..."
                : ylabel,
          },
        }}
        style={{
          width: "100%",
          height: "100%",
        }}
        useResizeHandler={true}
        config={{
          responsive: true,
          displaylogo: false,
        }}
      />
    </Paper>

    {getLoader && <GlobalLoader />}
  </Box>
);
}

export default LinePlotRaw;
